import { faArrowLeft, faPencil } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Scroll from "react-scroll";
import { getPromoCodeDetailAPI } from "../../../API/PromoCode";
import PageLoadingContent from "../../Reusable/PageLoadingContent";
import DataDisplayRowText from "../../Reusable/DataDisplayRowText";

const PromoCodeActive = ({ id }) => {
  const [errors, setErrors] = useState({});
  const [promoCode, setPromoCode] = useState({});

  const [isFetching, setFetching] = useState(false);

  function onPromoCodeDetailSuccess(response) {
    setPromoCode(response);
  }

  function onPromoCodeDetailError(apiErr) {
    setErrors(apiErr);

    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }

  function onPromoCodeDetailDone() {
    setFetching(false);
  }

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      window.scrollTo(0, 0);

      setFetching(true);
      getPromoCodeDetailAPI(
        id,
        onPromoCodeDetailSuccess,
        onPromoCodeDetailError,
        onPromoCodeDetailDone
      );
    }

    return () => {
      mounted = false;
    };
  }, [id]);

  return (
    <>
      {isFetching ? (
        <PageLoadingContent displayMessage={"Please wait"} />
      ) : (
        <>
          {promoCode && (
            <div className="columns">
              <div className="column">
                <DataDisplayRowText
                  label="Promo Code"
                  placeholder="0 or 1"
                  value={promoCode.name}
                />

                <DataDisplayRowText
                  label="Description"
                  placeholder="Description"
                  value={promoCode.description}
                />
                <DataDisplayRowText
                  label="Start Date"
                  placeholder="Start Date"
                  value={promoCode.startDate}
                />
                <DataDisplayRowText
                  label="End Date"
                  placeholder="End Date"
                  value={promoCode.endDate}
                />
                <DataDisplayRowText
                  label="discount"
                  placeholder="discount"
                  value={promoCode.discount + "%"}
                />
                <DataDisplayRowText
                  label="Usage Limit"
                  placeholder="Usage Limit"
                  value={promoCode.usageLimit}
                />
                <DataDisplayRowText
                  label="Status"
                  placeholder="Status"
                  value={promoCode.status}
                />

                <div className="columns">
                  <div className="column is-half">
                    <Link
                      to="/promo-code"
                      className="button is-fullwidth-mobile"
                    >
                      <FontAwesomeIcon className="fas" icon={faArrowLeft} />
                      &nbsp;Back to Promo Code
                    </Link>
                  </div>
                  <div className="column is-half has-text-right">
                    <Link className="button is-warning is-fullwidth-mobile">
                      <FontAwesomeIcon className="fas" icon={faPencil} />
                      &nbsp;Edit
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default PromoCodeActive;
